<template>
  <div id="login" class="justify-center flex items-center h-screen" v-if="$store.state.userData == null">
    <div class="w-600 flex justify-center shadow-md bg-white px-10 py-7">
      <a :href="googleLoginUrl" class="button">
        <font-awesome-icon icon="fa-brands fa-google" class="mr-3" /> Login With Google
      </a>
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router'

export default {
  name: 'Login',
  computed: {
    googleLoginUrl() {
      return process.env.VUE_APP_GOOGLE_LOGIN_URL;
    }
  },
  methods: {
    exchangeCodeForToken(code) {
      this.axios.post(
        process.env.VUE_APP_AUTHENTICATION_URL,
        {
          "method": "auth.exchangeCodeForToken",
          "params": { "code": code }
        },
        { 
          headers: {
            'Content-Type': 'application/json'
          }
        }
      ).then(response => {
        let expires = { expires: Math.floor(Date.now() / 1000) + 3600 };
        this.$store.commit('setUserData', { ...response.data.result, ...expires });
      });
    }
  },
  created() {
    const route = useRoute()
    if (route.query.authCode != null) {
      this.exchangeCodeForToken(route.query.authCode);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>